import { useEffect } from 'react';

import { AsyncThunk } from '@reduxjs/toolkit';

import { useAppDispatch } from '../../../store/hooks';

export const useGetTableEntriesByFeatureId = (
  dispatchFn: AsyncThunk<number, number, Record<string, unknown>>,
  featureId: number
): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(dispatchFn(featureId));
  }, [featureId]);
};
